export const RESET_CURRENT_FLOOR = "RESET_CURRENT_FLOOR";
export const FETCH_LIST_FLOOR_REQUEST = "FETCH_LIST_FLOOR_REQUEST";
export const FETCH_LIST_FLOOR_SUCCESS = "FETCH_LIST_FLOOR_SUCCESS";
export const FETCH_LIST_FLOOR_FAILURE = "FETCH_LIST_FLOOR_FAILURE";

export const FETCH_LIST_All_FLOOR_REQUEST = "FETCH_LIST_All_FLOOR_REQUEST";
export const FETCH_LIST_All_FLOOR_SUCCESS = "FETCH_LIST_All_FLOOR_SUCCESS";
export const FETCH_LIST_All_FLOOR_FAILURE = "FETCH_LIST_All_FLOOR_FAILURE";

export const FETCH_LIST_AllS_FLOOR_REQUEST = "FETCH_LIST_AllS_FLOOR_REQUEST";
export const FETCH_LIST_AllS_FLOOR_SUCCESS = "FETCH_LIST_AllS_FLOOR_SUCCESS";
export const FETCH_LIST_AllS_FLOOR_FAILURE = "FETCH_LIST_AllS_FLOOR_FAILURE";

// View single FLOOR
export const FETCH_FLOOR_REQUEST = "FETCH_FLOOR_REQUEST";
export const FETCH_FLOOR_SUCCESS = "FETCH_FLOOR_SUCCESS";
export const FETCH_FLOOR_FAILURE = "FETCH_FLOOR_FAILURE";

// Add FLOOR
export const ADD_FLOOR_REQUEST = "ADD_FLOOR_REQUEST";
export const ADD_FLOOR_SUCCESS = "ADD_FLOOR_SUCCESS";
export const ADD_FLOOR_FAILURE = "ADD_FLOOR_FAILURE";

// Edit FLOOR
export const UPDATE_FLOOR_REQUEST = "UPDATE_FLOOR_REQUEST";
export const UPDATE_FLOOR_SUCCESS = "UPDATE_FLOOR_SUCCESS";
export const UPDATE_FLOOR_FAILURE = "UPDATE_FLOOR_FAILURE";

// Delete FLOOR
export const DELETE_FLOOR_REQUEST = "DELETE_FLOOR_REQUEST";
export const DELETE_FLOOR_SUCCESS = "DELETE_FLOOR_SUCCESS";
export const DELETE_FLOOR_FAILURE = "DELETE_FLOOR_FAILURE";
